


























































































import Vue from 'vue';
import Component from 'vue-class-component';
import WebApiMessage from '@/core/messages/WebApiMessage.vue';
import Api from '@/project/http/Api.service';
import passwordService from '@/project/form/custom-rules/password';
import PasswordCondition from '@/project/auth/PasswordCondition.vue';

const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

@Component({
    components: { PasswordCondition, WebApiMessage }
})
export default class LoginPanel extends Vue {
    password: string = '';
    password2: string = '';
    token = '';
    done = false;
    busy = false;
    newUser = false;
    submitFailed = false;
    tokenExpired = false;

    created() {
        // Just a way to get token=xyz from a query string that can contain token=xyz&foo=baa#boo
        const tokenQuery = decodeURI(location.search).match(/token=([^&#]*)/i);
        this.newUser = location.search.toLowerCase().includes('newuser');
        if (tokenQuery?.length !== 2) return;
        this.token = tokenQuery[1];
        this.validateTokenExpired();
    }

    get isValidToken() {
        return this.token.match(guidPattern);
    }

    get hasLength(): boolean {
        return passwordService.hasLength(this.password);
    }

    get hasNumeric() {
        return passwordService.hasNumeric(this.password);
    }

    get hasUppercase() {
        return passwordService.hasUppercase(this.password);
    }

    get hasLowercase() {
        return passwordService.hasLowercase(this.password);
    }

    get hasSpecialChar() {
        return passwordService.hasSpecialChar(this.password);
    }

    gotoLogin() {
        this.$emit('goto-login');
    }

    forgotPassword() {
        this.$emit('forgot-pw');
    }

    close() {
        this.$emit('close');
    }

    cleanUpQuery() {
        this.$router.replace({ query: undefined });
    }

    async submit() {
        try {
            this.busy = true;
            await Api.authentication.resetPassword(this.password, this.token, 'resetpassword');
            this.done = true;
            this.cleanUpQuery();
        } catch (err) {
            // Ok, validation-messages will be shown
            this.submitFailed = true;
        } finally {
            this.busy = false;
        }
    }

    async validateTokenExpired() {
        try {
            this.busy = true;
            const tokenExpirationResponse = await Api.authentication.validateResetPasswordToken(this.token);
            this.tokenExpired = !tokenExpirationResponse.isTokenValid;
        } catch (err) {
        } finally {
            this.busy = false;
        }
    }

    resendToken() {
        this.forgotPassword();
    }
}
